import React from "react";
import { useChat } from "../../context/ChatContext";
import ChatInbox from "./ChatInbox";
import ChatPanel from "./ChatPanel";
import "./ChatPanel.css";

export default function ChatDock() {
  const {
    isInboxOpen,
    activeThread,
    inboxThreads,
    currentUser,
    connecting,
    error,
    members,
    toggleGroupChat,
    openThread,
    closeActiveThread,
    sendGroupMessage,
    openDirectChat,
    sendDirectMessage,
    loadMembers,
    canSendChat,
  } = useChat();

  if (!isInboxOpen) {
    return null;
  }

  return (
    <div className="chat-dock">
      {activeThread ? (
        <ChatPanel
          title={activeThread.title}
          messages={activeThread.messages}
          currentUserId={currentUser?.id}
          connecting={connecting}
          error={error}
          canSend={canSendChat}
          onBack={closeActiveThread}
          onClose={toggleGroupChat}
          onSend={(text) => {
            if (activeThread.kind === "group") {
              sendGroupMessage(text);
              return;
            }
            sendDirectMessage(activeThread.id, text);
          }}
          onClickUser={(userId, name) => {
            if (!canSendChat) {
              return;
            }
            if (!userId || String(userId) === String(currentUser?.id)) {
              return;
            }
            openDirectChat(userId, name);
          }}
        />
      ) : (
        <ChatInbox
          threads={inboxThreads}
          connecting={connecting}
          error={error}
          members={members}
          canSend={canSendChat}
          onClose={toggleGroupChat}
          onOpenThread={openThread}
          onStartDirect={openDirectChat}
          onLoadMembers={loadMembers}
        />
      )}
    </div>
  );
}
